import { post } from './base/index';

export default {
    deleteUserMailOTP: async (email, password) =>
        await post('users/deleteUserMailOTP', { email, password }),
    verifyDeleteOtp: async (otp) =>
        await post('users/verifyDeleteUserOTP', { otp }),
    deleteUserAccount: async (token) =>
        await post(`users/delete/${token}`),
};